import { Component, input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DropdownFieldComponent, DropdownOption } from '../../../atoms/forms/dropdown-field/dropdown-field.component';
import { ErrorFieldComponent } from '../../../atoms/forms/error-field/error-field.component';
import { ErrorTypeLabels, DEFAULT_ERROR_TYPE_LABELS } from '../../../shared/interfaces/error-messages.interface';

@Component({
  selector: 'htx-dropdown-field-with-error',
  imports: [CommonModule, DropdownFieldComponent, ErrorFieldComponent],
  templateUrl: './dropdown-field-with-error.component.html',
  styleUrl: './dropdown-field-with-error.component.scss',
  standalone: true
})
export class DropdownFieldWithErrorComponent {
  /** The FormControl that manages the dropdown value and validation state */
  ctrl = input.required<AbstractControl>();

  /** The label text displayed above the dropdown field */
  label = input<string>();

  /** Whether the field is required and should display a red asterisk indicator */
  required = input<boolean>(false);

  /** Array of dropdown options */
  options = input.required<DropdownOption[]>();

  /** Placeholder text when no option is selected */
  placeholder = input<string>('Select an option');

  /** When true, multiple options can be selected (control holds an array of values). */
  multiple = input<boolean>(false);

  /** Custom error messages for different validation types */
  errorMessages = input<ErrorTypeLabels>(DEFAULT_ERROR_TYPE_LABELS);

  /**
   * Returns the control as a FormControl for direct access to its properties and methods.
   */
  getControl(): FormControl {
    return this.ctrl() as FormControl;
  }
}
